/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

import type { Location, NavigateFunction, Params } from 'react-router-dom'

export type WithRouterProps<
  TParams extends Params<string | never> = {}, // eslint-disable-line @typescript-eslint/ban-types
  TState = unknown,
> = {
  router: {
    location: Location<TState>
    navigate: NavigateFunction
    params: Readonly<TParams>
  }
}

/**
 * Interim provider of router-related props to class-based components which
 * can't use the recommended hooks.
 *
 * Under-typed due to trickiness and intended short life.
 *
 * @deprecated
 */
function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    const location = useLocation()
    const navigate = useNavigate()
    const params = useParams()

    return (
      <Component
        router={{ location, navigate, params }}
        {...props} // this order to allow tests to easily override router data
      />
    )
  }

  ComponentWithRouterProp.displayName = `withRouter(${
    Component.displayName || Component.name || `Component`
  })`

  return ComponentWithRouterProp
}

export default withRouter
